import React, { useState } from 'react';

// Firebase imports
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

// Firebase configuration - Replace with your actual config
const firebaseConfig = {
  apiKey: "AIzaSyCkoi9450lR8lt_HC6bkK3aggrrRJihb4U",
  authDomain: "olewintechsolutions-cdfe3.firebaseapp.com",
  databaseURL: "https://olewintechsolutions-cdfe3-default-rtdb.firebaseio.com",
  projectId: "olewintechsolutions-cdfe3",
  storageBucket: "olewintechsolutions-cdfe3.appspot.com",
  messagingSenderId: "1076439102421",
  appId: "1:1076439102421:web:aad90d954290e0624bc35c",
  measurementId: "G-7FTMYFPYXB"
};

// Initialize Firebase
let app;
let db;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  console.log("Firebase initialized successfully");
} catch (error) {
  console.error("Firebase initialization error:", error);
}

const RequestForm = () => {
  // Form data state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    projectType: '',
    budget: '',
    budgetCurrency: 'INR',
    timeline: '',
    description: ''
  });
  
  // Currency options
  const currencies = [
    { code: 'USD', symbol: '$', name: 'US Dollar' },
    { code: 'EUR', symbol: '€', name: 'Euro' },
    { code: 'GBP', symbol: '£', name: 'British Pound' },
    { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
    { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' }
  ];
  
  // Form progress state
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 4;
  const progressPercentage = (currentStep / totalSteps) * 100;
  
  // Form submission state
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });
  
  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };
  
  // Step navigation
  const handleNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    }
  };
  
  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      window.scrollTo(0, 0);
    }
  };
  
  // Validate current step
  const validateStep = () => {
    switch(currentStep) {
      case 1:
        return formData.name.trim() !== '' && formData.email.trim() !== '';
      case 2:
        return formData.projectType !== '';
      case 3:
        return true; // Optional fields
      case 4:
        return formData.description.trim() !== '' && formData.description.trim().length >= 10;
      default:
        return true;
    }
  };
  
  // Get budget ranges based on selected currency
  const getBudgetRanges = () => {
    const selectedCurrency = currencies.find(c => c.code === formData.budgetCurrency);
    const symbol = selectedCurrency ? selectedCurrency.symbol : '$';
    
    return [
      { value: `Below ${symbol}10,000`, label: `Below ${symbol}10,000` },
      { value: `${symbol}10,000 - ${symbol}25,000`, label: `${symbol}10,000 - ${symbol}25,000` },
      { value: `${symbol}25,000 - ${symbol}50,000`, label: `${symbol}25,000 - ${symbol}50,000` },
      { value: `${symbol}50,000 - ${symbol}100,000`, label: `${symbol}50,000 - ${symbol}100,000` },
      { value: `${symbol}100,000 - ${symbol}250,000`, label: `${symbol}100,000 - ${symbol}250,000` },
      { value: `Above ${symbol}250,000`, label: `Above ${symbol}250,000` },
      { value: "Not Sure", label: "Not Sure" }
    ];
  };
  
  // Submit form data to Firebase
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });
    
    try {
      console.log("Starting form submission...");
      
      // Check if Firebase is initialized
      if (!db) {
        throw new Error('Firebase is not properly initialized');
      }
      
      // Validate required fields
      if (!formData.name.trim()) {
        throw new Error('Name is required');
      }
      if (!formData.email.trim()) {
        throw new Error('Email is required');
      }
      if (!formData.projectType) {
        throw new Error('Project type is required');
      }
      if (!formData.description.trim() || formData.description.trim().length < 10) {
        throw new Error('Project description must be at least 10 characters long');
      }
      
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email.trim())) {
        throw new Error('Please enter a valid email address');
      }
      
      // Create submission data object
      const submissionData = {
        name: formData.name.trim(),
        email: formData.email.trim().toLowerCase(),
        phone: formData.phone.trim() || '',
        company: formData.company.trim() || '',
        projectType: formData.projectType,
        budget: formData.budget || 'Not specified',
        budgetCurrency: formData.budgetCurrency,
        timeline: formData.timeline || 'Not specified',
        description: formData.description.trim(),
        status: 'pending',
        createdAt: serverTimestamp(),
        submittedAt: new Date().toISOString(),
        userAgent: navigator.userAgent || 'Unknown',
      };
      
      console.log("Submitting data:", submissionData);
      
      // Add document to Firebase Firestore
      const docRef = await addDoc(collection(db, "projectRequests"), submissionData);
      
      console.log("Document successfully written with ID:", docRef.id);
      
      setSubmitStatus({
        type: 'success',
        message: `✅ Your request has been successfully submitted! Reference ID: ${docRef.id.substring(0, 8).toUpperCase()}. We will contact you within 24 hours!`
      });
      
      // Clear form after success
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        projectType: '',
        budget: '',
        budgetCurrency: 'INR',
        timeline: '',
        description: ''
      });
      
      // Reset to first step
      setCurrentStep(1);
      
    } catch (error) {
      console.error("Submission error:", error);
      
      let errorMessage = 'There was an error submitting your request. ';
      
      // Handle specific errors
      if (error.code === 'permission-denied') {
        errorMessage = '🚫 Access denied. Please contact support for assistance.';
      } else if (error.code === 'unavailable') {
        errorMessage = '⚠️ Service temporarily unavailable. Please try again in a few minutes.';
      } else if (error.code === 'failed-precondition') {
        errorMessage = '⚠️ Database configuration issue. Please contact support.';
      } else if (error.code === 'invalid-argument') {
        errorMessage = '⚠️ Invalid data submitted. Please check your inputs.';
      } else if (error.message.includes('Firebase')) {
        errorMessage = '🔧 Configuration error. Please contact support.';
      } else if (error.message.includes('required') || error.message.includes('valid')) {
        errorMessage = `⚠️ ${error.message}`;
      } else {
        errorMessage = `❌ Submission failed: ${error.message}`;
      }
      
      setSubmitStatus({
        type: 'error',
        message: errorMessage
      });
    } finally {
      setIsSubmitting(false);
      window.scrollTo(0, 0);
    }
  };
  
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      padding: '2rem 1rem'
    },
    card: {
      maxWidth: '800px',
      margin: '0 auto',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      padding: '2rem'
    },
    header: {
      textAlign: 'center',
      marginBottom: '2rem'
    },
    title: {
      color: '#17a2b8',
      fontWeight: 'bold',
      fontSize: '2rem',
      marginBottom: '0.5rem'
    },
    subtitle: {
      color: '#6c757d',
      fontSize: '1rem'
    },
    progressContainer: {
      marginBottom: '2rem'
    },
    stepLabels: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '1rem'
    },
    stepLabel: {
      fontSize: '0.9rem',
      fontWeight: '500'
    },
    progressBar: {
      width: '100%',
      height: '8px',
      backgroundColor: '#e9ecef',
      borderRadius: '4px',
      overflow: 'hidden',
      marginBottom: '1rem'
    },
    progressFill: {
      height: '100%',
      backgroundColor: '#17a2b8',
      borderRadius: '4px',
      transition: 'width 0.3s ease'
    },
    stepCounter: {
      textAlign: 'center',
      color: '#6c757d',
      fontSize: '0.9rem'
    },
    stepTitle: {
      color: '#007bff',
      fontSize: '1.5rem',
      fontWeight: '600',
      marginBottom: '1.5rem'
    },
    formGroup: {
      marginBottom: '1.5rem'
    },
    label: {
      display: 'block',
      marginBottom: '0.5rem',
      fontWeight: '500',
      color: '#333'
    },
    input: {
      width: '100%',
      padding: '0.75rem',
      border: '1px solid #ced4da',
      borderRadius: '6px',
      fontSize: '1rem',
      transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
    },
    inputFocus: {
      borderColor: '#007bff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,0.25)'
    },
    inputError: {
      borderColor: '#dc3545'
    },
    select: {
      width: '100%',
      padding: '0.75rem',
      border: '1px solid #ced4da',
      borderRadius: '6px',
      fontSize: '1rem',
      backgroundColor: 'white'
    },
    textarea: {
      width: '100%',
      padding: '0.75rem',
      border: '1px solid #ced4da',
      borderRadius: '6px',
      fontSize: '1rem',
      minHeight: '120px',
      resize: 'vertical'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '2rem'
    },
    button: {
      padding: '0.75rem 1.5rem',
      borderRadius: '6px',
      fontSize: '1rem',
      fontWeight: '500',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    buttonPrimary: {
      backgroundColor: '#007bff',
      color: 'white'
    },
    buttonSecondary: {
      backgroundColor: '#6c757d',
      color: 'white'
    },
    buttonSuccess: {
      backgroundColor: '#28a745',
      color: 'white'
    },
    buttonDisabled: {
      backgroundColor: '#e9ecef',
      color: '#6c757d',
      cursor: 'not-allowed'
    },
    alert: {
      padding: '1rem',
      borderRadius: '6px',
      marginBottom: '1.5rem',
      border: '1px solid transparent'
    },
    alertSuccess: {
      backgroundColor: '#d4edda',
      borderColor: '#c3e6cb',
      color: '#155724'
    },
    alertError: {
      backgroundColor: '#f8d7da',
      borderColor: '#f5c6cb',
      color: '#721c24'
    },
    closeButton: {
      float: 'right',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      color: 'inherit',
      opacity: 0.5
    },
    spinner: {
      display: 'inline-block',
      width: '1rem',
      height: '1rem',
      border: '2px solid transparent',
      borderTop: '2px solid currentColor',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginRight: '0.5rem'
    },
    descriptionHelper: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '0.875rem',
      marginTop: '0.5rem'
    }
  };

  // Add CSS animation for spinner
  const spinnerStyle = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  // Step 1: Personal Information
  const renderStep1 = () => {
    return (
      <div>
        <h4 style={styles.stepTitle}>Step 1: Personal Information</h4>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Full Name*</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your full name"
            style={{
              ...styles.input,
              ...(formData.name.trim() === '' && currentStep > 1 ? styles.inputError : {})
            }}
            required
          />
        </div>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Email Address*</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email address"
            style={{
              ...styles.input,
              ...(formData.email.trim() === '' && currentStep > 1 ? styles.inputError : {})
            }}
            required
          />
        </div>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter your phone number"
            style={styles.input}
          />
        </div>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Company/Organization</label>
          <input
            type="text"
            name="company"
            value={formData.company}
            onChange={handleChange}
            placeholder="Enter your company name"
            style={styles.input}
          />
        </div>
        
        <div style={styles.buttonContainer}>
          <div></div>
          <button 
            type="button"
            onClick={handleNextStep}
            disabled={!validateStep()}
            style={{
              ...styles.button,
              ...(validateStep() ? styles.buttonPrimary : styles.buttonDisabled)
            }}
          >
            Next →
          </button>
        </div>
      </div>
    );
  };
  
  // Step 2: Project Details
  const renderStep2 = () => {
    return (
      <div>
        <h4 style={styles.stepTitle}>Step 2: Project Details</h4>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Project Type*</label>
          <select
            name="projectType"
            value={formData.projectType}
            onChange={handleChange}
            style={{
              ...styles.select,
              ...(formData.projectType === '' && currentStep > 2 ? styles.inputError : {})
            }}
            required
          >
            <option value="">Select Project Type</option>
            <option value="Website Development">Website Development</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Custom Software">Custom Software</option>
            <option value="AI/ML Solution">AI/ML Solution</option>
            <option value="Blockchain Development">Blockchain Development</option>
            <option value="Cloud Migration">Cloud Migration</option>
            <option value="DevOps Implementation">DevOps Implementation</option>
            <option value="Cybersecurity">Cybersecurity</option>
            <option value="Digital Transformation">Digital Transformation</option>
            <option value="IoT Solution">IoT Solution</option>
            <option value="Consulting Services">Consulting Services</option>
            <option value="Other">Other</option>
          </select>
        </div>
        
        <div style={styles.buttonContainer}>
          <button 
            type="button"
            onClick={handlePrevStep}
            style={{...styles.button, ...styles.buttonSecondary}}
          >
            ← Previous
          </button>
          <button 
            type="button"
            onClick={handleNextStep}
            disabled={!validateStep()}
            style={{
              ...styles.button,
              ...(validateStep() ? styles.buttonPrimary : styles.buttonDisabled)
            }}
          >
            Next →
          </button>
        </div>
      </div>
    );
  };
  
  // Step 3: Timeline & Budget
  const renderStep3 = () => {
    const budgetRanges = getBudgetRanges();
    
    return (
      <div>
        <h4 style={styles.stepTitle}>Step 3: Timeline & Budget</h4>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Currency</label>
          <select
            name="budgetCurrency"
            value={formData.budgetCurrency}
            onChange={handleChange}
            style={styles.select}
          >
            {currencies.map(currency => (
              <option key={currency.code} value={currency.code}>
                {currency.code} - {currency.name} ({currency.symbol})
              </option>
            ))}
          </select>
        </div>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Budget Range</label>
          <select
            name="budget"
            value={formData.budget}
            onChange={handleChange}
            style={styles.select}
          >
            <option value="">Select Budget Range</option>
            {budgetRanges.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Timeline</label>
          <select
            name="timeline"
            value={formData.timeline}
            onChange={handleChange}
            style={styles.select}
          >
            <option value="">Select Expected Timeline</option>
            <option value="Less than 1 month">Less than 1 month</option>
            <option value="1-3 months">1-3 months</option>
            <option value="3-6 months">3-6 months</option>
            <option value="6-12 months">6-12 months</option>
            <option value="More than 12 months">More than 12 months</option>
            <option value="Not Sure">Not Sure</option>
          </select>
        </div>
        
        <div style={styles.buttonContainer}>
          <button 
            type="button"
            onClick={handlePrevStep}
            style={{...styles.button, ...styles.buttonSecondary}}
          >
            ← Previous
          </button>
          <button 
            type="button"
            onClick={handleNextStep}
            style={{...styles.button, ...styles.buttonPrimary}}
          >
            Next →
          </button>
        </div>
      </div>
    );
  };
  
  // Step 4: Project Description
  const renderStep4 = () => {
    const descriptionLength = formData.description.trim().length;
    const isValidDescription = descriptionLength >= 10;
    
    return (
      <div>
        <h4 style={styles.stepTitle}>Step 4: Project Description</h4>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Project Description*</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Please describe your project, requirements, and goals in detail..."
            style={{
              ...styles.textarea,
              ...(!isValidDescription && formData.description.length > 0 ? styles.inputError : {})
            }}
            required
          />
          <div style={styles.descriptionHelper}>
            <span style={{ color: isValidDescription ? '#28a745' : '#dc3545' }}>
              {descriptionLength < 10 ? 
                `Minimum 10 characters required (${descriptionLength}/10)` : 
                `✓ Description looks good (${descriptionLength} characters)`
              }
            </span>
          </div>
        </div>
        
        <div style={styles.buttonContainer}>
          <button 
            type="button"
            onClick={handlePrevStep}
            style={{...styles.button, ...styles.buttonSecondary}}
          >
            ← Previous
          </button>
          <button 
            type="submit" 
            disabled={isSubmitting || !validateStep()}
            style={{
              ...styles.button,
              ...(isSubmitting || !validateStep() ? styles.buttonDisabled : styles.buttonSuccess)
            }}
          >
            {isSubmitting ? (
              <>
                <span style={styles.spinner}></span>
                Submitting...
              </>
            ) : (
              '🚀 Submit Request'
            )}
          </button>
        </div>
      </div>
    );
  };
  
  // Render current step content
  const renderStepContent = () => {
    switch(currentStep) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4();
      default:
        return renderStep1();
    }
  };
  
  return (
    <div style={styles.container}>
      <style>{spinnerStyle}</style>
      
      <div style={styles.card}>
        <div style={styles.header}>
          <h2 style={styles.title}>Request a Consultation</h2>
          <p style={styles.subtitle}>Fill out the form below and we'll get back to you within 24 hours</p>
          <hr />
        </div>
        
        {submitStatus.message && (
          <div style={{
            ...styles.alert,
            ...(submitStatus.type === 'success' ? styles.alertSuccess : styles.alertError)
          }}>
            <button 
              style={styles.closeButton}
              onClick={() => setSubmitStatus({ type: '', message: '' })}
            >
              ×
            </button>
            <div dangerouslySetInnerHTML={{ __html: submitStatus.message }} />
          </div>
        )}
        
        <div style={styles.progressContainer}>
          <div style={styles.stepLabels}>
            <span style={{
              ...styles.stepLabel,
              color: currentStep >= 1 ? '#007bff' : '#6c757d',
              fontWeight: currentStep >= 1 ? 'bold' : 'normal'
            }}>
              Personal Info
            </span>
            <span style={{
              ...styles.stepLabel,
              color: currentStep >= 2 ? '#007bff' : '#6c757d',
              fontWeight: currentStep >= 2 ? 'bold' : 'normal'
            }}>
              Project Details
            </span>
            <span style={{
              ...styles.stepLabel,
              color: currentStep >= 3 ? '#007bff' : '#6c757d',
              fontWeight: currentStep >= 3 ? 'bold' : 'normal'
            }}>
              Timeline & Budget
            </span>
            <span style={{
              ...styles.stepLabel,
              color: currentStep >= 4 ? '#007bff' : '#6c757d',
              fontWeight: currentStep >= 4 ? 'bold' : 'normal'
            }}>
              Description
            </span>
          </div>
          
          <div style={styles.progressBar}>
            <div style={{
              ...styles.progressFill,
              width: `${progressPercentage}%`
            }}></div>
          </div>
          
          <p style={styles.stepCounter}>
            Step {currentStep} of {totalSteps}
          </p>
        </div>
        
        <form onSubmit={handleSubmit}>
          {renderStepContent()}
        </form>
      </div>
    </div>
  );
};

export default RequestForm;